/* Ricerche recenti (localStorage) + ricerche popolari nello stato vuoto della
   predictive search, come i grandi multimarca (Zalando/ASOS, cfr. Baymard).
   Le pill riusano le classi native del tema. Si re-inietta dopo ogni morph
   del contenitore risultati. */
(function () {
  var KEY = 'wmie-recent-searches';
  var MAX = 5;
  /* Auto-curate: brand più venduti calcolati in Liquid (search-modal.liquid,
     data-wmie-popular). La lista statica resta solo come fallback. */
  var POPULAR = ['hogan uomo', 'hogan', 'saint barth', 'golden goose', 'borsa pinko'];
  try {
    var el = document.querySelector('script[data-wmie-popular]');
    var auto = el && JSON.parse(el.textContent);
    if (auto && auto.length >= 5) POPULAR = auto.slice(0, 5);
  } catch (e) {}

  function getRecent() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }

  function saveRecent(term) {
    term = (term || '').trim().toLowerCase();
    if (term.length < 2) return;
    var list = getRecent().filter(function (t) { return t !== term; });
    list.unshift(term);
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }

  function pillRow(title, terms, extraClass) {
    var ul = document.createElement('ul');
    ul.className = 'predictive-search-results__list predictive-search-results__wrapper predictive-search-results__wrapper-queries list-unstyled wmie-suggestions ' + (extraClass || '');
    var h = document.createElement('h4');
    h.className = 'predictive-search-results__title';
    h.textContent = title;
    ul.appendChild(h);
    terms.forEach(function (term) {
      var li = document.createElement('li');
      li.className = 'predictive-search-results__card--query';
      var a = document.createElement('a');
      a.className = 'pills__pill predictive-search-results__pill';
      a.href = '/search?q=' + encodeURIComponent(term);
      a.textContent = term;
      li.appendChild(a);
      ul.appendChild(li);
    });
    return ul;
  }

  /* Le foto prodotto hanno sfondi diversi (bianco o grigio studio): con object-fit
     contain le bande laterali sarebbero visibili. Campiona l'angolo di ogni immagine
     e usa quel colore come sfondo della card, così le bande diventano invisibili. */
  var bgCache = {};
  function sampleImageBg(img) {
    var src = img.currentSrc || img.src;
    if (!src || img.dataset.wmieBgDone) return;
    img.dataset.wmieBgDone = '1';
    if (bgCache[src]) { img.style.backgroundColor = bgCache[src]; return; }
    fetch(src, { mode: 'cors' })
      .then(function (r) { return r.blob(); })
      .then(function (b) { return createImageBitmap(b); })
      .then(function (bmp) {
        var c = document.createElement('canvas');
        c.width = c.height = 1;
        var ctx = c.getContext('2d');
        ctx.drawImage(bmp, 0, 0, 8, 8, 0, 0, 1, 1);
        var d = ctx.getImageData(0, 0, 1, 1).data;
        var col = 'rgb(' + d[0] + ',' + d[1] + ',' + d[2] + ')';
        bgCache[src] = col;
        img.style.backgroundColor = col;
      })
      .catch(function () {});
  }

  function sampleAllImages() {
    document.querySelectorAll('.predictive-search .resource-card__image').forEach(function (img) {
      if (img.complete && (img.currentSrc || img.src)) sampleImageBg(img);
      else img.addEventListener('load', function () { sampleImageBg(img); }, { once: true });
    });
  }

  function inject() {
    var component = document.querySelector('predictive-search-component');
    if (!component) return;
    var input = component.querySelector('#cmdk-input');
    var inner = component.querySelector('.predictive-search-results__inner');
    if (!inner || (input && input.value.trim() !== '')) return;
    if (inner.querySelector('.wmie-suggestions')) return;

    var recent = getRecent();
    var frag = document.createDocumentFragment();
    if (recent.length) frag.appendChild(pillRow('Ricerche recenti', recent, 'wmie-recent'));
    frag.appendChild(pillRow('Trending', POPULAR, 'wmie-popular'));
    inner.insertBefore(frag, inner.firstChild);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var component = document.querySelector('predictive-search-component');
    if (!component) return;

    var style = document.createElement('style');
    style.textContent = '.wmie-suggestions{flex-wrap:wrap}.wmie-suggestions .predictive-search-results__title{flex-basis:100%;margin-block:0 var(--margin-xs)}';
    document.head.appendChild(style);

    inject();
    sampleAllImages();
    new MutationObserver(function () {
      inject();
      sampleAllImages();
    }).observe(component, { childList: true, subtree: true });

    component.addEventListener('submit', function () {
      var input = component.querySelector('#cmdk-input');
      if (input) saveRecent(input.value);
    }, true);

    /* il tema naviga via keydown, non con un submit reale */
    component.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target && e.target.id === 'cmdk-input') saveRecent(e.target.value);
    }, true);

    component.addEventListener('click', function (e) {
      var pill = e.target.closest('a.predictive-search-results__pill, .predictive-search__search-button');
      if (!pill) return;
      var input = component.querySelector('#cmdk-input');
      if (pill.classList.contains('predictive-search__search-button')) {
        if (input) saveRecent(input.value);
      } else {
        saveRecent(pill.textContent);
      }
    }, true);
  });
})();
